import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { VerkaufspreisSelectorService } from './verkaufspreis-selector.service';

export class Verkaufspreis {
    verkaufspreis_id: number;
    bezeichnung: string;
    erstellt: Date;
    erstellt_von: number;
    editiert: Date;
    editiert_von: number;
}

export interface VerkaufspreisApi {
    records: Verkaufspreis[];
    count: number;
}

@Component({
    selector: 'kiene-verkaufspreis-selector',
    templateUrl: './verkaufspreis-selector.component.html',
    styleUrls: ['./verkaufspreis-selector.component.scss'],
})
export class VerkaufspreisSelectorComponent implements OnInit, OnChanges {
    verkaufspreise: Verkaufspreis[] = [];
    vkCtrl = new UntypedFormControl();

    @Input('selectedVerkaufspreisId') selectedVerkaufspreisId: number;
    @Input('allowEmptySelection') allowEmptySelection = true;
    @Input('disabled') disabled = false;

    @Output('verkaufspreisSelectionChanged')
    verkaufspreisSelectionChanged = new EventEmitter<Verkaufspreis>();

    constructor(private _service: VerkaufspreisSelectorService) {}

    ngOnInit() {
        this.loadVerkaufspreise();
    }

    ngOnChanges() {
        this.applySelectedVerkaufspreis();
        if (this.disabled) {
            this.vkCtrl.disable();
        } else {
            this.vkCtrl.enable();
        }
    }

    comparator(v1: Verkaufspreis, v2: Verkaufspreis) {
        return Number(v1?.verkaufspreis_id) === Number(v2?.verkaufspreis_id);
    }

    loadVerkaufspreise() {
        this._service.loadVerkaufspreise().subscribe(response => {
            this.verkaufspreise = [...response.records].sort((a, b) => {
                if (a.verkaufspreis_id === 0) {
                    return -1;
                }
                if (b.verkaufspreis_id === 0) {
                    return 1;
                }
                return a.verkaufspreis_id - b.verkaufspreis_id;
            });
            this.applySelectedVerkaufspreis();
        });
    }

    private applySelectedVerkaufspreis(): void {
        if (this.selectedVerkaufspreisId === null || this.selectedVerkaufspreisId === undefined) {
            this.vkCtrl.setValue(null, { emitEvent: false });
            return;
        }
        const selectedId = Number(this.selectedVerkaufspreisId);
        const match = this.verkaufspreise.find(v => Number(v.verkaufspreis_id) === selectedId);
        this.vkCtrl.setValue(match ?? { verkaufspreis_id: selectedId }, { emitEvent: false });
    }

    verkaufspreisChanged(event: MatSelectChange) {
        this.verkaufspreisSelectionChanged.emit(event.value);
    }
}
